<template>
    <div id="split">
        <a-modal
                title="Split"
                :visible="visible"
                @cancel="handleCancelSplit"
                width="60%"
        >
            <template slot="footer">
                <a-button type="primary" @click="saveSplit" size="small">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-row style="margin: 4px 0">
                <img @click="addSplitEvt" v-if="tableData.length > 0 ? false:true" class="sbxs" src="../../../assets/img/ss-add.png" width="22" height="22">
                <img style="margin-left: 4px;" @click="deleSplit" class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
            </a-row>
            <a-row>
                <div id="splitTable">
                    <vxe-table
                        border
                        show-overflow
                        max-height="350"
                        ref="splitTable"
                        size="mini"
                        :data="tableData">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                        </template>
                        <vxe-table-column type="checkbox" width="60" disabled></vxe-table-column>
                        <vxe-table-column field="recQty" :title="$t('pubGicSet.RecQty')" show-header-overflow="ellipsis" show-overflow="ellipsis" >
                            <template v-slot="{ row }">
                                <a-input-number size="small" @change="changeNumberRecqty" :placeholder="$t('publicLang.PleaseEnter')" :min="0" v-model="row.recQty" style="width: 100%;"/>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="location" :title="$t('pubGicSet.Location')" show-header-overflow="ellipsis" show-overflow="ellipsis">
                            <template v-slot="{ row }">
                                <!--<a-input v-model="row.location" placeholder="Location"  v-if="row.disabled"/>-->
                                <a-input-search
                                        :placeholder="$t('publicLang.PleaseEnter')"
                                        style="width: 100%;"
                                        v-model="row.location"
                                        size="small"
                                />
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                lookupParams:{},
                visible: false,
                tableData: [],
                splitUid: '',
                sumecQtyRnum: 0
            }
        },
        methods:{
            handleCancelSplit(){
                this.visible = false
            },
            showSplit(id){
                this.visible = true
                this.splitUid = id
                this.tableData = []
                this.init()
            },
            init(){
                ajax.get(api.SPLITTABLE,{uid: this.splitUid}).then(res=>{
                    if(res.code == 200){
                        let data = res.data
                        data.disabled = true
                        this.sumecQtyRnum = res.data.recQty
                        this.tableData.push(res.data)
                        this.$nextTick(()=>{
                            let elInput = $('#splitTable>.vxe-table>.vxe-table--body-wrapper>.vxe-table--body>tbody').children().children('td:eq(0)').find('.vxe-cell').find('.vxe-checkbox').find('input')
                            let elspan = $('#splitTable>.vxe-table>.vxe-table--body-wrapper>.vxe-table--body>tbody').children().children('td:eq(0)').find('.vxe-cell').find('.vxe-checkbox').find('span')
                            let elLable = $('#splitTable>.vxe-table>.vxe-table--body-wrapper>.vxe-table--body>tbody').children().children('td:eq(0)').find('.vxe-cell').find('.vxe-checkbox')
                            elLable.addClass('is--disabled')
                            elInput.attr('disabled', true)
                            elspan.addClass('vxe-checkbox--icon')
                        })
                    }
                })
            },
            addSplitEvt(){
                this.tableData.push({recQty: 0, location: null,disabled: false})
            },
            changeNumberRecqty(val){
                let num = this.sumecQtyRnum
                let delNum = 0
                let t = this.tableData
                for(let i in t){
                    if(!t[i].disabled){
                        if(parseFloat(val).toString() == 'NaN'){
                            t[i].recQty = 0
                            return
                        }else{
                            delNum =  delNum + t[i].recQty
                            if(delNum > num){
                                t[i].recQty = 0
                                return
                            }
                        }
                    }
                }
                if(delNum > num){
                    this.$customMessage.error(this.$t('publicLang.NotAllowToOverReceive'));
                    return
                }
                this.tableData[0].recQty = num - delNum
            },
            deleSplit(){
                let updateRecords = this.$refs.splitTable.getCheckboxRecords()
                if(updateRecords.length > 0){
                    let t = 0
                    for(let i in updateRecords){
                         t = t + updateRecords[i].recQty
                    }
                    this.tableData[0].recQty = this.tableData[0].recQty + t
                    this.$refs.splitTable.removeCheckboxRow()
                }else{
                    this.$customMessage.error(this.$t('publicLang.PleaseSltAtleast'));
                }
            },
            saveSplit(){
                let delNum = 0
                let t = this.tableData
                for(let i in t){
                    if(t[i].location == '' || t[i].location == null){
                        this.$customMessage.error(this.$t('pubGicSet.LocationISrequired'));
                        return
                    }
                    if(!t[i].disabled){
                        delNum =  delNum + t[i].recQty
                    }
                }
               if(delNum > this.sumecQtyRnum){
                   this.$customMessage.error(this.$t('publicLang.NotAllowToOverReceive'));
                   return
               }
                let params = {
                    splits: this.tableData,
                    uid: this.splitUid
                }
                ajax.post(api.SPLITSAVE,params).then(res=>{
                    if(res.code == 200){
                        this.visible = false
                        this.$emit('cancelModalVisible','init')
                    }
                })
            }
        }
    }
</script>